export default {
  title: {
    userManagement: '用户管理',
    roleManagement: '角色管理',
    userAdd: '增添用户',
    userEdit: '编辑用户',
    resetPassword: '重置密码',
    accountCancellation: '用户注销'
  },
  menu: '用户管理',
  label: {
    name: '姓名',
    company: '公司',
    email: '邮箱地址',
    role: '角色',
    updateTime: '更新时间',
    status: '状态',
    option: '操作',
    companyName: '公司名称',
    addUser: '新增用户',
    editUser: '编辑用户',
    firstName: '名字',
    lastName: '姓氏',
    chineseName: '中文姓名',
    primaryEmail: '邮箱地址',
    secondaryEmail: '其他邮箱地址',
    mobile: '手机号码',
    employeeId: '员工ID',
    reportTo: '汇报对象',
    programType: '项目类别',
    clientName: '客户名称',
    costCentre: '成本中心',
    roleType: '角色类型',
    roleSource: '可分配的角色:',
    roleTarget: '已分配角色:',
    roleTitle: '角色管理',
    roleHead: '给 {name} 在 {company} 分配角色 {email}',
    resetPassword: '重置密码',
    password: '新密码：',
    confirmPassword: '请再次输入密码：',
    emailOrMobile: '邮箱/手机号',
    emailAfterCancellation: '注销后的邮箱账号',
    disableAccount: '禁用',
    unbindWeChat: '解除微信绑定关系',
    cancellation: '注销'
  },
  placeholder: {
    firstName: '请输入名字',
    lastName: '请输入姓氏',
    chineseName: '请输入中文姓名',
    company: '请选择公司',
    secondaryEmail: '请输入其他邮箱地址',
    mobile: '请输入手机号码',
    employeeId: '请输入员工ID',
    reportTo: '请选择汇报对象',
    programType: '请选择项目类别',
    clientName: '请输入客户名称',
    costCentre: '请输入成本中心',
    roleType: '请选择角色类型',
    role: '请选择角色',
    email: '请输入邮箱',
    primaryEmail: '请输入邮箱',
    phone: '请输入手机',
    name: '请输入姓名',
    password: '请输入密码',
    confirmPassword: '请再次输入密码',
    search: '搜索（邮箱/姓名）'
  },
  btn: {
    addUser: '添加用户',
    exportUser: '导出用户',
    resetPassword: '重置密码',
    role: '角色'
  },
  message: {
    optionSuccess: '操作成功',
    optionField: '操作失败',
    userTip: '{activeCount}个活跃账户数/{totalCount}个总可用账户数',
    userRequired: '这是必填项。',
    emailExist: '此邮箱地址已被注册。',
    emailValid: '输入一个有效的 e-mail 地址。',
    mobileExist: '该手机号码已经被绑定了。',
    resetPasswordError: '24小时内最多重置5次密码，请隔天再试.',
    resetPasswordSuccess: '重置密码邮件已发, 可在几分钟内查收.',
    expireDateClosed: '请联系菁客申请添加更多的账户',
    confirmPasswordSame: '请确认密码相同',
    cancellationSuccess: '注销成功'
  }
}
